module.exports = __webpack_public_path__ + "img/dance.dd78a223.svg";